import {api} from 'services/api';
import {ObjectId} from 'types/object-id';
import {RelatedProduct} from 'types/project';
import {ResponseData} from 'types/response-data';

const saveRelatedProducts = api.injectEndpoints({
  endpoints: builder => ({
    saveRelatedProducts: builder.mutation<Response, SaveRelatedProductsRequest>(
      {
        query: body => {
          return {
            method: 'POST',
            url: `projects/${body.id}/related-products`,
            body: {variants: body.variants},
          };
        },
        // @ts-expect-error the api instance declares no tagTypes
        invalidatesTags: (_result, _error, arg) => [
          {type: 'projects', id: arg.id},
        ],
      }
    ),
  }),
});

export type SaveRelatedProductsRequest = {
  id?: ObjectId;
  variants: {variant_id: number}[];
};

type Response = ResponseData<Array<RelatedProduct>>;

export const {useSaveRelatedProductsMutation} = saveRelatedProducts;
